module.exports = __webpack_public_path__ + "img/thumbnail-zen.88d22837.jpg";